import { defineModule } from '../../manifest.js';
/**
 * Procurement — an approved Phase 1 SKU.
 *
 * REGISTERED, NOT BUILT. There is no Procurement domain in the repository: no
 * tables, no package, no permissions and no routes. `lifecycle: 'proposed'`
 * says so, and §3 is explicit that registering a module is not the same as
 * shipping one — a module cannot be sold until it is registered, which is the
 * order this follows.
 *
 * It therefore declares NO features and NO editions beyond the base one. A
 * feature key invented before anybody designed the feature ends up in
 * entitlement and billing records under a name no review ever saw (§3.2), and
 * the same argument applies to metered events (S4-6). Both lists stay empty
 * until the Procurement inventory is approved.
 *
 * THE KEY IS `procurement` AND THE KERNEL IS `procurement_kernel`. Finance
 * declares `requiredCore: ['procurement_kernel']` — the mandatory purchasing
 * context every tenant has. It does NOT require this module. That separation
 * is what keeps "Finance works without Procurement" true, and it is enforced
 * at registry load: a sellable key colliding with a capability name is
 * refused (§5).
 */
export const manifest = defineModule({
    moduleKey: 'procurement',
    name: 'Procurement',
    description: 'Purchase requisitions, approvals, purchase orders, supplier selection and receipting.',
    kind: 'commercial',
    sellable: true,
    navigationModuleKey: 'procurement',
    features: [],
    editions: [{ code: 'ed_01', description: 'Base edition', features: [], limits: ['user'] }],
    limitTypes: ['user'],
    meteredEvents: [],
    requiredCore: [
        'tenancy',
        'hierarchy',
        'identity',
        'authz',
        'audit',
        'approvals',
        'party_master',
        'procurement_kernel',
        'numbering',
        'money',
        'tax',
        'attachments',
    ],
    // Finance turns an approved order into a bill; Procurement is coherent
    // without it, which is what makes this optional rather than a bundle (§5).
    optionalModules: ['finance'],
    integrationDeps: [],
    lifecycle: 'proposed',
    commercialRelease: 'phase_1',
    version: 1,
});
//# sourceMappingURL=module.manifest.js.map